import React from 'react';
import { BookOpen, Droplet, Sparkles, User, Settings, Check } from 'lucide-react';
import { Card } from '../ui/Card';
export function Curriculum() {
  const modules = [{
    icon: <Droplet className="w-6 h-6 text-blue-500" data-id="element-76" />,
    title: 'Cuidado Corporal',
    items: ['Crema corporal hidratante (emulsión estable)', 'Loción corporal relajante', 'Bálsamo labial reparador', 'Jabón líquido para el cuerpo (suave)', 'Bomba de baño efervescente', 'Desodorante natural efectivo']
  }, {
    icon: <Sparkles className="w-6 h-6 text-purple-500" data-id="element-77" />,
    title: 'Cuidado Facial',
    items: ['Limpiador facial respetuoso', 'Tónico facial equilibrante', 'Exfoliante facial suave', 'Mascarilla facial nutritiva', 'Crema hidratante facial diaria', "Crema 'antiarrugas' (enfoque pro-aging)"]
  }, {
    icon: <User className="w-6 h-6 text-pink-500" data-id="element-78" />,
    title: 'Maquillaje Natural',
    items: ['Base de maquillaje en polvo', 'Rubor en crema natural', 'Labial hidratante con color', 'Sombra de ojos mineral', 'Delineador en gel', 'Máscara de pestañas (higiene estricta)']
  }, {
    icon: <Settings className="w-6 h-6 text-gray-600" data-id="element-79" />,
    title: 'Cuidado Masculino',
    items: ['Jabón y crema de afeitar', 'Aftershave balm calmante', 'Gel limpiador facial masculino', 'Bálsamo labial mate (sin brillo)', 'Exfoliante corporal energizante']
  }];
  return <section className="py-20 bg-[#F9FAFB]" data-id="element-80">
      <div className="container mx-auto px-4" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-83">
            ¿Qué vas a aprender exactamente?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-84">
            No es solo un recetario. Es un curso completo en formato libro
            digital que cubre todas las necesidades de cuidado personal.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16" data-id="element-85">
          {modules.map((module, idx) => <Card key={idx} className="p-6 hover:shadow-md transition-shadow duration-300" data-id="element-86">
              <div className="flex items-center gap-3 mb-4 border-b border-gray-100 pb-4" data-id="element-87">
                <div className="p-2 bg-gray-50 rounded-lg" data-id="element-88">{module.icon}</div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-89">
                  {module.title}
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-90">
                {module.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-91">
                    <Check className="w-4 h-4 text-[#4A6741] mt-1 flex-shrink-0" data-id="element-92" />
                    <span className="text-sm md:text-base" data-id="element-93">{item}</span>
                  </li>)}
              </ul>
            </Card>)}
        </div>

        {/* HOW IT WORKS / EXTRA MODULE */}
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200" data-id="element-94">
          <div className="bg-[#4A6741] p-6 text-white text-center" data-id="element-95">
            <h3 className="text-2xl font-bold" data-id="element-96">
              Módulo Extra: El Secreto del Profesional
            </h3>
            <p className="opacity-90" data-id="element-97">
              Lo que nadie te cuenta sobre la fabricación artesanal
            </p>
          </div>
          <div className="p-8 grid md:grid-cols-2 gap-8" data-id="element-98">
            <div data-id="element-99">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-100">
                <BookOpen className="w-5 h-5 text-[#C06C54]" data-id="element-101" />
                Técnica y Teoría
              </h4>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-102">
                <li data-id="element-103">• Utensilios necesarios y cómo usarlos</li>
                <li data-id="element-104">• Control estricto de temperaturas</li>
                <li data-id="element-105">• Fases de emulsión (A, B, C) explicadas</li>
                <li data-id="element-106">• Glosario de términos técnicos</li>
              </ul>
            </div>
            <div data-id="element-107">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-108">
                <Settings className="w-5 h-5 text-[#C06C54]" data-id="element-109" />
                Gestión y Calidad
              </h4>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-110">
                <li data-id="element-111">• Desinfección y esterilización</li>
                <li data-id="element-112">• Tabla de fallos y cómo corregirlos</li>
                <li data-id="element-113">• Plantillas: Ficha de lote y Etiquetas</li>
                <li data-id="element-114">• Checklist de control de calidad</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}